import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from '~env';
import { AnnualDeclarationFormCollection } from '../model/annual-declaration.model';
import { AttachedDocuments } from '../model/company-identification.model';

@Injectable({
  providedIn: 'root',
})
export class AnnualDeclarationQueryService implements OnDestroy {

  private QUERY_API = environment.legalEntityQueryApi;

  destroy$ = new Subject<void>();

  constructor(
    private http: HttpClient
  ) { }

  generatePdf(legalEntityId: string, annualDeclarationFormCollection: AnnualDeclarationFormCollection): Observable<AttachedDocuments> {
    const url = `${this.QUERY_API}/legalentity/${legalEntityId}/Form/generateAnnualDeclarationSummaryPdf`;
    return this.http.post<any>(url, annualDeclarationFormCollection);
  }

  generateSummaryPdf(legalEntityId: string, annualDeclarationFormCollection: AnnualDeclarationFormCollection): Observable<AttachedDocuments> {
    const url = `${this.QUERY_API}/legalentity/${legalEntityId}/Form/generateLegalEntitySummaryAsDateOf`;
    return this.http.post<any>(url, annualDeclarationFormCollection);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
